import { axiosInstance } from './axiosInstance';

export const sendDeviceMetadata = (data) => {
  return axiosInstance.post('/device_metadata', data);
};